import EVENTS from './mini-cart-events.js';

class ToggleCart extends HTMLElement {
  connectedCallback() {
    this.cartLink = this.querySelector('a[href*="/cart"]');

    document.addEventListener(EVENTS.ajaxProductAdded, (evt) => {
      this.updateCount(evt.detail?.product?.item_count);
    });

    document.addEventListener(EVENTS.cartUpdated, (evt) => {
      this.updateCount(evt.detail?.cart?.item_count);
    });

    // Uncomment below to open drawer on cart icon click
    // instead of navigating to /cart page:
    //
    // if (this.cartLink) {
    //   this.cartLink.addEventListener('click', (e) => {
    //     e.preventDefault();
    //     document.dispatchEvent(
    //       new CustomEvent(EVENTS.cartOpen, { bubbles: true })
    //     );
    //   });
    // }
  }

  updateCount(count) {
    if (count === undefined || count === null) return;
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
}

customElements.define('toggle-cart', ToggleCart);
export default ToggleCart;
